module.exports = __webpack_public_path__ + "static/media/invert.eb0349d2.svg";